import { render, staticRenderFns } from "./obitosPendentes.vue?vue&type=template&id=7fbcaf04"
import script from "./obitosPendentes.vue?vue&type=script&lang=js"
export * from "./obitosPendentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports